import { requests } from "../../requests";
import { mergeProjectUrl } from "../../http/config";
import { EndPoints } from "../../utils/EndPoints";

export const bagsOverviewService = {
  // ?type=table is paginated server-side (page_size=100, max_page_size=500).
  // Fetches one page at a time; pass a prior response's `next` URL to page
  // forward (e.g. on scroll), or omit it to fetch page 1. summary.total_used_bags
  // is a full aggregate independent of the page, so every page carries it.
  getPage: async (nextUrl) => {
    try {
      const options = nextUrl
        ? { method: "GET", url: nextUrl }
        : {
            method: "GET",
            url: mergeProjectUrl(EndPoints.Reports.dashboardBags),
            params: { type: "table" },
          };
      const response = await requests(options);

      if (!response || response.error) {
        return { error: true, data: response?.data || "Error fetching bags dashboard" };
      }

      return {
        error: false,
        results: response.data?.results || [],
        next: response.data?.next || null,
        count: response.data?.count || 0,
        summary: response.data?.summary || {},
      };
    } catch (error) {
      return { error: true, data: error?.message || "Error fetching bags dashboard" };
    }
  },
};

// Rows come from GET reports/dashboard/bags/?type=table — one row per
// active BagPurchaseOrder: { id, brand_id, brand, packaging_id, packaging,
// bag_invoice_number, date, order_quantity, supplier, dispatched_quantity,
// balance_quantity, status }. summary.total_used_bags is already aggregated
// server-side (from BriBagInventory), not summed from rows.
export const computeOverview = (rows = [], summary = {}) => {
  const bagsOrdered = rows.reduce((sum, row) => sum + (Number(row.order_quantity) || 0), 0);
  const bagsDispatched = rows.reduce(
    (sum, row) => sum + (Number(row.dispatched_quantity) || 0),
    0
  );
  const balanceBags = bagsOrdered - bagsDispatched;
  const totalUsedBags = Number(summary.total_used_bags) || 0;

  return { bagsOrdered, bagsDispatched, balanceBags, totalUsedBags };
};
